import { SERVER_KEY_MAP, YANDEX_ID } from 'configs/constants';
import { TServerIds } from 'models/types';
import { findErrorOperator } from './findErrorOperator';

export const checkHESuccess = (operatorId: TServerIds = '0') => {
  const { ym } = window as any;
  if (!!ym ) {
    ym(YANDEX_ID, 'reachGoal', `HE_success`);
    operatorId !== '0' && ym(YANDEX_ID, 'reachGoal', `HE_success_${SERVER_KEY_MAP[operatorId]?.name}`);
  }
};

export const checkSubscribe = (operatorId: TServerIds = '0') => {
  const { ym } = window as any;

  if (!!ym ) {
    ym(YANDEX_ID, 'reachGoal', 'Subscribe_button');
    operatorId !== '0' && ym(YANDEX_ID, 'reachGoal', `Subscribe_button_${SERVER_KEY_MAP[operatorId]?.name}`);
  }
};


export const checkHEError = (url: string) => {
  const { ym } = window as any;
  
  if (!!ym) {
    ym(YANDEX_ID, 'reachGoal', `HE_error_${findErrorOperator(url)}`);
  }
};